<template>
  <div class="home page bg">
    <div class="gif-box" :class="{'anim-home': gifAnim}">
      <img src="../assets/p1/gif/1.png" alt="" />
      <img src="../assets/p1/gif/2.png" alt="" />
      <img src="../assets/p1/gif/3.png" alt="" />
      <img src="../assets/p1/gif/4.png" alt="" />
      <img src="../assets/p1/gif/5.png" alt="" />
      <img src="../assets/p1/gif/6.png" alt="" />
      <img src="../assets/p1/gif/7.png" alt="" />
      <img src="../assets/p1/gif/8.png" alt="" />
      <img src="../assets/p1/gif/9.png" alt="" />
      <img src="../assets/p1/gif/10.png" alt="" />
      <img src="../assets/p1/gif/11.png" alt="" />
      <img src="../assets/p1/gif/12.png" alt="" />
      <img src="../assets/p1/gif/13.png" alt="" />
      <img src="../assets/p1/gif/14.png" alt="" />
      <img src="../assets/p1/gif/15.png" alt="" />
      <img src="../assets/p1/gif/16.png" alt="" />
      <img src="../assets/p1/gif/17.png" alt="" />
      <img src="../assets/p1/gif/18.png" alt="" />
      <img src="../assets/p1/gif/19.png" alt="" />
      <img src="../assets/p1/gif/20.png" alt="" />
      <img src="../assets/p1/gif/21.png" alt="" />
      <img src="../assets/p1/gif/22.png" alt="" />
      <img src="../assets/p1/gif/23.png" alt="" />
      <img src="../assets/p1/gif/24.png" alt="" />
      <img src="../assets/p1/gif/25.png" alt="" />
      <img src="../assets/p1/gif/26.png" alt="" />
      <img src="../assets/p1/gif/27.png" alt="" />
      <img src="../assets/p1/gif/28.png" alt="" />
      <img src="../assets/p1/gif/29.png" alt="" />
      <img src="../assets/p1/gif/30.png" alt="" />
    </div>

    <div v-show="homeVideo" class="home-video">
      <div class="skip" @click="skip">跳过</div>
      <!-- <video id="video" src="../../public/videos/home.mp4" preload="auto" x5-playsinline="" playsinline="" webkit-playsinline=""></video> -->
      <video id="video" src="../../public/videos/home.mp4" preload="auto" playsinline="" webkit-playsinline=""></video>
    </div>

    <div class="btn-box" @click="btnHandler">
      <img class="btn" :class="{'anim-btn': btnAnim}" src="../assets/p1/btn.png" alt="开始按钮">
    </div>
  </div>
</template>

<script>
import { updateShare } from '../../lib/wxShare'

export default {
  name: 'home',
  data: function() {
    return {
      // gif图的动画
      gifAnim: false,
      // 按钮的动画
      btnAnim: false,
      // 视频
      homeVideo: false,
    }
  },
  mounted () {
    // 首页初始化
    console.log('====>home mounted')
    const self = this

    // 安卓 微信 环境下，给视频添加属性
    if (this.$store.state.isAndroid) {
      const videoP = document.getElementById('video')
      videoP.setAttribute('x5-video-player-type', 'h5')
      videoP.setAttribute('x5-video-player-fullscreen', 'false')

      videoP.removeAttribute('x5-playsinline')
    }

    // 页面渲染完成
    this.$store.commit('setPageReady')

    setTimeout(() => {
      this.gifAnim = true
    }, 100)

    // 5s后开始按钮动画
    setTimeout(() => {
      this.btnAnim = true
    }, 3500)
  },
  methods: {
    nextPage () {
      const player = document.getElementById('mp3-text')
      player.play()

      this.$router.replace('upload')
      this.homeVideo = false
      this.btnAnim = false
    },

    // 首页按钮的点击事件
    btnHandler () {
      this.homeVideo = true
      const videoP = document.getElementById('video')
      videoP.play()
      videoP.addEventListener('ended', () => {
        this.nextPage()
      })
    },

    // 跳过视频
    skip () {
      const videoP = document.getElementById('video')
      videoP.pause();

      this.nextPage()
    }
  }
}
</script>

<style scoped>
.home{
  position: relative;
  width: 20rem;
  height: 100%;
  overflow: hidden;
}
/* gif的盒子 */
.gif-box{
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;

  position: absolute;
  width: 600rem;
  vertical-align: top;
  font-size: 0;
}
.gif-box img{
  width: 20rem;
  height: 38.65rem;
}
.home-gif{
  width: 100%;
}
.home-bg{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  /* background-image: url(../assets/p1/bg.png); */
  background-size: 100% auto;
  background-position: 50% 0%;
  background-repeat: no-repeat;
  opacity: 0;
  transition: opacity .3s ease;
  -webkit-transition: opacity .3s ease;
}

.skip{
  position: absolute;
  top: 15px;
  right: 20px;
  z-index: 999;

  border-radius: 12px;
  width: 60px;
  height: 26px;
  /* background-color: rgba(0, 0, 0, 0.6); */
  background-image: url(../assets/p1/skip.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  font-size: 0;
}

.home-video{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  background-color: black;
  overflow: hidden;
}
.home-video video{
  width: 100%;
}

/* 开始的按钮 */
.btn-box{
  position: absolute;
  top: 28rem;
  left: 5.8rem;
  z-index: 5;
  width: 9.34rem;
  vertical-align: top;
  font-size: 0;
  opacity: 0;
}
.btn{
  opacity: 0;
  width: 9.34rem;
}

/* 动画部分 */
.anim-home {
  -webkit-animation: home 3s steps(29, end) forwards;
  animation: home 3s steps(29, end) forwards;
}
@-webkit-keyframes home {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translate3d(-580rem, 0px, 0px);
  }
}
@keyframes home {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translate3d(-580rem, 0px, 0px);
  }
}

.anim-btn{
  -webkit-transform-origin: center center;
  transform-origin: center center;
  -webkit-animation: scalein .33s ease both;
  animation: scalein .33s ease both;
}
@-webkit-keyframes scalein {
  0% {
    opacity: 0;
    -webkit-transform: scale(2);
  }
  100% {
    opacity: 1;
    -webkit-transform: scale(1);
  }
}
@keyframes scalein {
  0% {
    opacity: 0;
    transform: scale(2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
